<template>
  <DBox
    :id="'cmp-licencing-licence-sidewindow-royalty_account'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="`${$t('add_new')} ${$t('tracks')}`"
  >
    <NTable
      class="dbox1"
      id="licencing-licence-sidewindow-royalty_account"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td    v-bind="tdcon('royalty_account')">
            <span style="white-space: nowrap;" @click="onRoyaltyAccountClick(item)" class="ut-link ut-text-accent5 txtov">{{ item["royalty_account_name"] }}</span>
          </td>
          <td v-bind="tdcon('contract')">
            <span class="ut-link ut-text-accent5 txtov" @click="onContractClick(item)" style="white-space: nowrap;">{{ item["contract_name"] }}</span>
          </td>
          <td v-bind="tdcon('asset_count')">
            <span>{{ item["asset_count"] }}</span>
          </td>
          <td v-bind="tdcon('territory')">
            <span>{{ item["territory"] }}</span>
          </td>
          <td v-bind="tdcon('licence_type')">
            <span>{{ item["licence_type"] }}</span>
          </td>

          <td v-bind="tdcon('royalty_rate')">
            <span>{{ item["royalty_rate"] }}</span>
          </td>
          <td v-bind="tdcon('adjustment')">
            <span>{{ item["adjustment"] }}</span>
          </td>
          <td v-bind="tdcon('deduction')">
            <span>{{ item["deduction"] }}</span>
          </td>
          
          <!-- <td v-bind="tdcon('costs_info')" :title="transfromInfo(item['info'])">
            <span>{{ transfromInfo(item["info"]) }}</span>
          </td> -->
        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import { royaltyAccountsListLDTRoutes, royaltyContractsListLDTRoutes } from "../../../royalty/router/routes";

export default {
  props: {
    selectedLicenceDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerHeight: 32,
        headerStyle: 3,
        rowHeight: 32,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function() {
      // return [
      //   createTableHeader("royalty_account", {}),
      //   createTableHeader("contract", { f: 1 }),

      //   createTableHeader("track", {}),
      //   createTableHeader("share", { ta: "right", f: 0.5 }),
      //   createTableHeader("costs_info", { f: 2 })
      // ];

      return [
        createTableHeader("royalty_account", { minw:240  }),
        createTableHeader("contract", {  minw:240 }),
        createTableHeader("asset_count", {mw:85, ta:"center",text:`${this.$t("asset")} ${this.$t("count")}` }),
        createTableHeader("territory", { ta:"center"}),
        createTableHeader("licence_type", {}),
        createTableHeader("royalty_rate", {mw:85, ta: "right" }),
        createTableHeader("adjustment", { mw:85, ta: "right"}),
        createTableHeader("deduction", { mw:85, ta: "right"})
      ]
    },

    list: function() {
      return this.selectedLicenceDetails.royalty_accounts || [];
    }
  },

  methods: {
    transfromInfo: function(info) {
      let reducedInfo = info.reduce((accum, cur) => {
        if (info.length > 1) {
          return (accum += `${cur["royalty_rate"]}% ${this.$t(
            cur?.license_type
          ) || "General"} | `);
        } else {
          return (accum += `${cur["royalty_rate"]}% ${this.$t(
            cur?.license_type
          ) || "General"}`);
        }
      }, "");

      // console.log(", SPRING",reducedInfo,", SLICE STRING",reducedInfo.slice(0,- 1))

      return info.length > 1 ? reducedInfo.slice(0, -2) : reducedInfo;
      //console.log("INFO",info)
    },

    onContractClick: function(item) {
      console.log(item);
      
      this.$router.push({
        name: royaltyContractsListLDTRoutes.names.tab,
        params: {
          contract_id: item.contract_id,
          tab: "overview"
        }
      });
    },

    onRoyaltyAccountClick: function(item) {
      console.log(item);
      this.$router.push({
        name: royaltyAccountsListLDTRoutes.names.tab,
        params: {
          royalty_account_id: item.royalty_account_id,
          tab: "overview"
        }
      });
    }
  }
};
</script>
<style lang="scss">
.cmp-licencing-licence-sidewindow-royalty_account {
  .dt-ntable {
    tbody {
      tr {
          min-height: 32px;
        td {
          //justify-content: flex-start !important;
          height: 100%;
          display: flex;

          width: 100%;
          white-space: pre-wrap;
        }
      }
    }
  }
}
</style>
